import { ConversationPersonaFromApi } from '@sdk/messages/types/apiTypes';
import { UserFromApi } from '@sdk/users/types/UserFromApi';
import { ObjectWithId } from '@sdk/common/types/ObjectWithId';

import { MessageType } from '@web/conversations/types/MessageType';
import {
  MessagePost,
  Message,
  MessageMeta,
  MessagePersona,
} from '@web/conversations/types/Message';

export const isMessagePost = (message: Message): message is MessagePost =>
  message.type === MessageType.MESSAGE;

export const isMessageMeta = (message: Message): message is MessageMeta =>
  message.type === MessageType.CREATION || message.type === MessageType.RENAMING;

export const isMessagePersona = (message: Message): message is MessagePersona =>
  message.type === MessageType.ADDITION || message.type === MessageType.REMOVAL;

export const isConversationPersonaUser = (
  interlocutor: ConversationPersonaFromApi
): interlocutor is UserFromApi => (interlocutor as UserFromApi).type === 'user';

export const isMessageUser = (user: ObjectWithId | UserFromApi): user is UserFromApi =>
  (user as UserFromApi).type === 'user';
